import { useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { Autocomplete, IconButton, TextField, Tooltip } from "@mui/material";
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import axios from "axios";
import Swal from 'sweetalert2'
import { useFormik } from "formik";
import { Edit } from '@mui/icons-material';
import * as yup from 'yup';
import { EditRater } from "./EditRater";
import * as XLSX from 'xlsx';
import { saveAs } from "file-saver";

const validationSchema = yup.object({
    firstName: yup.string("Enter the first name").required("First Name is required"),
    lastName: yup.string("Enter the last name").required("Last Name is required"),
    email: yup
      .string('Enter the email')
      .email('Enter a valid email')
      .matches(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,'Enter a valid email')
      .required('Email is required'),
    raterGroup: yup.object().required("Rater Group is required!")
})

export const RatersList = ({subject, raters, show, setShow, assessmentSentAt, init, ...rest}) => {
    const [isSent, setIsSent] = useState(null)
    const handleClose = () => setShow(false);
    const [raterGroups, setRaterGroups] = useState([])
    const [subjectRaters, setSubjectRaters] = useState([])
    const [isSubjectNameUpdating, setIsSubjectNameUpdating] = useState(false)
    const [subjectFirstName, setSubjectFirstName] = useState('')
    const [subjectLastName, setSubjectLastName] = useState('')
    const [errorSubjectFirstName, setErrorSubjectFirstName] = useState('')
    const [errorSubjectLastName, setErrorSubjectLastName] = useState('')
    const [showEditRaterModal, setShowEditRaterModal] = useState(false)
    const [rater, setRater] = useState({})

    useEffect(() => {
        console.log("subject====>",subject);
        getRaterGroups()
        getRaters()
        formik.setFieldValue('subjectId', subject?.id)
        formik.setFieldValue('assessmentId', subject?.assessmentId)
        setIsSubjectNameUpdating(false)
        setSubjectFirstName(subject.firstName)
        setSubjectLastName(subject.lastName)
    }, [subject]);

    const getRaterGroups = () => {
        axios.get(`/api/groups?assessmentId=${subject.assessmentId}`)
        .then(function (response) {
            let result = response.data;
            if(result.success){
                setRaterGroups(result.data)
            }
        })
    }

    const getRaters = () => {
        axios.get(`/api/subjectRaters?subjectId=${subject.id}`)
        .then(function (response) {
            let result = response.data;
            if(result.success){
                setSubjectRaters(result.data)
            }
        })        
    }

    const initialValues = {
        assessmentId: subject?.assessmentId,
        subjectId: subject?.id,
        firstName: '',
        lastName: '',
        email: '',
        raterGroup: null
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: values => {
            handleSubmit(values);
        }
    });

    const handleSubmit = (values) =>{
        axios.post(`api/addRater`, values).then(res => {
            if(res.data.success){
                Swal.fire(res.data.message, '', 'success').then(result => {
                    getRaters()
                    formik.resetForm();
                })                
            } 
            else{
                Swal.fire(res.data.message, '', 'error')
            }
        }).catch((error) => {
            Swal.fire(error.response.data.message, '', 'error')
        });       
    }

    const handleGroupChange = (e, value) => {
        if(value && value.id){
            formik.setFieldValue('raterGroup', value);            
        }
        else{
            formik.setFieldValue('raterGroup', null);
        }
    }

    useEffect(() => {
        if (isSent !== null) {
            const timer = setTimeout(() => {
                setIsSent(null);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [isSent]);

    const sendReminder = (raterId) => {
        console.log("raterId==",raterId)
        if(assessmentSentAt === null){
            Swal.fire('The assessment has not been sent yet!')
        }
        else{
            axios.post(`api/sendReminder`, {raterId: raterId, assessmentId: subject.assessmentId}).then(res => {
                if(res.data.success){
                    setIsSent(raterId)            
                } 
                else{
                    Swal.fire(res.data.message, '', 'error')
                }
            }).catch((error) => {
                console.log("error==",error)
            });
        }
    }

    const sendReminderToSelf = () => {
        // console.log("raterId==",raterId)
        if(assessmentSentAt === null){
            Swal.fire('The assessment has not been sent yet!')
        }
        else{
            axios.post(`api/sendReminderToSelf`, {subjectId: subject.id, assessmentId: subject.assessmentId}).then(res => {
                if(res.data.success){
                    Swal.fire(res.data.message, '', 'success')    
                } 
                else{
                    Swal.fire(res.data.message, '', 'error')
                }
            }).catch((error) => {
                console.log("error==",error)
            });
        }
    }

    const sendBulkReminder = () => {
        axios.post(`api/sendReminderBluk`, subject).then(res => {
            if(res.data.success){
                Swal.fire(res.data.message, '', 'success').then(result => {
                })                
            } 
            else{
                Swal.fire(res.data.message, '', 'error')
            }
        }).catch((error) => {
            setShow(false)
            Swal.fire(error.response.data.message, '', 'error')
        });
    }

    const removeRater = (id) => {
        Swal.fire({
            title: 'Are you sure you want to delete?',
            showCancelButton: true,
            confirmButtonColor: '#45a7c4',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.isConfirmed) { 
                axios.delete(`/api/removeRater/${id}`).then((res) =>{
                    if(res.data.success){                             
                        Swal.fire('Deleted!', '', 'success')
                        getRaters();
                    } 
                }).catch((error) => {
                    console.log(error);                     
                    Swal.fire(error.message, '', 'info')           
                });
            } else if (result.isDenied) {
              Swal.fire('Cancelled!', '', 'info')
            }
        }) 
    }

    const handleChangeSubjectFirstName = (e) => {
        setSubjectFirstName(e.target.value)
    }

    const handleChangeSubjectLastName = (e) => {
        setSubjectLastName(e.target.value)
    }

    const handleUpdateSubjectName = () => {
        if(subjectFirstName === ''){
            setErrorSubjectFirstName('First Name is required')
        }
        else{
            setErrorSubjectFirstName('')
        }
        if(subjectLastName === ''){
            setErrorSubjectLastName('Last Name is required')
        }
        else{
            setErrorSubjectLastName('')
        }
        if(subjectFirstName !== '' && subjectLastName !== ''){
            axios.put(`api/assessment/updateSubjectName`, {id: subject.id, firstName: subjectFirstName, lastName: subjectLastName}).then(res => {
                if(res.data.success){
                    setIsSubjectNameUpdating(false)
                    init()
                    Swal.fire(res.data.message, '', 'success').then(result => {
                    })                
                } 
                else{
                    Swal.fire(res.data.message, '', 'error')
                }
            }).catch((error) => {
                Swal.fire(error.response.data.message, '', 'error')
            });
        }        
    }

    const editRater = (data) => {
        setRater(data)
        setShowEditRaterModal(true)
    }

    const addRatersByUploadFile = async (data) =>{
        axios.post(`api/addRatersByUploadFile`, {ratersData: data, assessmentId: subject?.assessmentId, subjectId : subject?.id}).then(res => {
            if(res.data.success){
                Swal.fire(res.data.message, '', 'success').then(result => {
                    getRaters()
                    formik.resetForm();
                })                
            } 
            else{
                Swal.fire(res.data.message, '', 'error')
            }
        }).catch((error) => {
            Swal.fire(error.response.data.message, '', 'error')
        });       
    }

    const checkRatersViaApi = async (raterArray) => {
        try {
            const result = await axios.post(`api/groups/findRaterInGroup`, {
                assessmentId: subject?.assessmentId,
                rater: raterArray
            });
            if (result?.data?.success) {
                return result.data;
            } else {
                Swal.fire(result.data.message, '', 'error')
                return false;
            }
        } catch (error) {
            Swal.fire(error.response.data.message, '', 'error');
            return false; 
        }
    }

    const onFileUpload = async (file) => { 
        if(file){
            const reader = new FileReader();
            reader.onload = async (event) => {
                const wb = XLSX.read(event.target.result);
                const sheets = wb.SheetNames;
                const fileName = file.name;
                const fileExtension = fileName.split('.').pop();
                if (fileExtension === 'xlsx' || fileExtension === 'xls') {
                    if (sheets.length) {
                        const rows = XLSX.utils.sheet_to_json(wb.Sheets[sheets[0]]);
                        // console.log('row',rows);
                        const column1Values = rows.map(row => row['FirstName']);
                        const column2Values = rows.map(row => row['LastName']);
                        const column3Values = rows.map(row => row['Email']);
                        const column4Values = rows.map(row => row['Group']);
                        const hasEmptyFname = column1Values.some(fname => !fname || fname.trim() === '');
                        if (hasEmptyFname) {
                            Swal.fire("First name contain empty values.", '', 'error');
                            return;
                        }
                        const hasEmptyLname = column2Values.some(lname => !lname || lname.trim() === '');
                        if (hasEmptyLname) {
                            Swal.fire("Last name contain empty values.", '', 'error');
                            return;
                        }
                        const hasEmptyEmail = column3Values.some(email => !email || email.trim() === '');
                        if (hasEmptyEmail) {
                            Swal.fire("Email contain empty values.", '', 'error');
                            return;
                        }
                        const hasEmptyGroup = column4Values.some(group => !group || group.trim() === '');                        
                        if (hasEmptyGroup) {
                            Swal.fire("Group contain empty values.", '', 'error');
                            return;
                        }            
                        const uniqueColumn4Val = [...new Set(column4Values)];
                        // console.log('uniqueColumn4Val', uniqueColumn4Val);
                        const checkResult = await checkRatersViaApi(uniqueColumn4Val);                        
                        // console.log("checkResult===>", checkResult);
                        if (checkResult && checkResult.success && checkResult.data) {
                            let raterData = checkResult.data;
                            const mergedRows = rows.map(row => ({
                                ...row,
                                Group: raterData.find(group => group.name === row.Group) || row.Group // Find matching group or fallback
                            }));
                            // console.log("mergedRows===>", mergedRows);
                            await addRatersByUploadFile(mergedRows);
                        }
                                             
                    
                    }
                } else {
                    Swal.fire('Must be Upload excel file', '', 'error');
                }
            }
            reader.readAsArrayBuffer(file);
        }
        
    };

    const downloadRaterLinks = () => {
        axios.get(`/api/assessmentLinks?assessmentId=${subject.assessmentId}&subjectId=${subject.id}`)
        .then(function (response) {
            let result = response.data;
            if(result.success){
                // console.log("assessments",result.data)
                const data = result.data
              
                // Create a worksheet from the data
                const ws = XLSX.utils.aoa_to_sheet(data);
            
                // Create a workbook with the worksheet
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            
                // Write the Excel file
                const excelFile = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            
                // Save the file using file-saver
                const blob = new Blob([excelFile], { type: "application/octet-stream" });
                saveAs(blob, subject.name+" Assessment Links.xlsx");
            }
        })
        
    }

    return (
        <>
        <Modal show={show} size="xl" onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Subject & Raters</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="col-md-12">
                    <div style={{marginBottom: "15px"}}>
                        <div className="row">
                            <div className="col-md-4">
                                <h4>Subject Details</h4>
                            </div>
                            <div className="col-md-8 text-end">
                                <button onClick={downloadRaterLinks} className="btn btn-primary text-white">Download Links</button>
                                <button onClick={sendReminderToSelf} className="btn btn-primary text-white ms-2">Send Reminder to Self</button>
                                <button onClick={sendBulkReminder} className="btn btn-primary text-white ms-2">Send Reminder to all Pending</button>
                            </div>
                        </div>
                    </div>                                        
                    <div className="table-responsive row mt-4 mb-3">
                        <table className="table table-striped">
                            <tbody>
                                <tr>
                                    <th width="30%" scope="col">Subject Name</th>
                                    <td>
                                        {isSubjectNameUpdating ?
                                        <div className="row">
                                            <div className="col-md-5">
                                                <div className="input-group input-group-merge">
                                                    <span id="basic-icon-default-firstName" className="input-group-text"><i className="bx bx-user"></i></span>
                                                    <input type="text" name="firstName" className="form-control" placeholder="First Name" value={subjectFirstName} onChange={handleChangeSubjectFirstName}/>
                                                </div>
                                                <div className="text-danger">{errorSubjectFirstName}</div>                                                
                                            </div>
                                            <div className="col-md-5">
                                                <div className="input-group input-group-merge">
                                                    <span id="basic-icon-default-lastName" className="input-group-text"><i className="bx bx-user"></i></span>
                                                    <input type="text" name="lastName" className="form-control" id="basic-icon-default-lastName" placeholder="Last Name" value={subjectLastName} onChange={handleChangeSubjectLastName}/>
                                                </div>
                                                <div className="text-danger">{errorSubjectLastName}</div>
                                            </div>
                                            <div className="col-md-2">
                                                <button type="button" className="btn w-100 btn-primary mt-1" onClick={handleUpdateSubjectName}>Save</button>
                                            </div>
                                        </div>
                                        :
                                        <div>
                                            {subjectFirstName+' '+subjectLastName}
                                            <IconButton onClick={() => setIsSubjectNameUpdating(true)}>
                                                <Edit />
                                            </IconButton>
                                        </div>
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="col">Subject Email</th>
                                    <td>{subject.email}</td>
                                </tr>
                                <tr>
                                    <th scope="col">Assessment Status</th>
                                    <td>
                                    {
                                        subject.status === 'Pending' ? 
                                        <Chip label="Pending" color="info" size="small" variant="outlined" />
                                        :
                                        <Chip label="Done" color="success" size="small" />
                                    } 
                                    </td>
                                </tr>
                                {/* <tr>
                                    <th scope="col">Assessment Link</th>
                                    <td>{subject.assessmentLink}</td>
                                </tr> */}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-md-12">
                    <h4>Rater List</h4>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row d-flex align-items-center mb-3">
                            <div className="col">
                                <div className="mb-3">
                                    <label className="form-label" htmlFor="basic-icon-default-name">First Name</label>
                                    <div className="input-group input-group-merge">
                                        <span id="basic-icon-default-name" className="input-group-text"><i className="bx bx-user"></i></span>
                                        <input type="text" name="firstName" className="form-control" id="basic-icon-default-name" placeholder="First Name" aria-label="First Name" aria-describedby="basic-icon-default-fullname2" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.firstName}/>
                                    </div>
                                    {formik.touched.firstName && formik.errors.firstName && (<div className="text-danger">{formik.errors.firstName}</div>)}
                                </div>
                            </div>
                            <div className="col">
                                <div className="mb-3">
                                    <label className="form-label" htmlFor="basic-icon-default-name">Last Name</label>
                                    <div className="input-group input-group-merge">
                                        <span id="basic-icon-default-name" className="input-group-text"><i className="bx bx-user"></i></span>
                                        <input type="text" name="lastName" className="form-control" id="basic-icon-default-name" placeholder="Last Name" aria-label="Last Name" aria-describedby="basic-icon-default-fullname2" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.lastName}/>
                                    </div>
                                    {formik.touched.lastName && formik.errors.lastName && (<div className="text-danger">{formik.errors.lastName}</div>)}
                                </div>
                            </div>
                            <div className="col">
                                <div className="mb-3">
                                    <label className="form-label" htmlFor="basic-icon-default-email">Rater Email</label>
                                    <div className="input-group input-group-merge">
                                        <span className="input-group-text"><i className="bx bx-envelope"></i></span>
                                        <input type="email" name="email" id="basic-icon-default-email" className="form-control" placeholder="Rajiv.doe@example.com" aria-label="Rajiv.doe@example.com" aria-describedby="basic-icon-default-email2" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.email}/>
                                    </div>
                                    {formik.touched.email && formik.errors.email && (<div className="text-danger">{formik.errors.email}</div>)}
                                </div>
                            </div>
                            <div className="col">
                                <div className="mb-3">
                                    <label className="form-label" htmlFor="basic-icon-default-phone">Rater Group</label>   
                                    <Autocomplete
                                        id="raterGroupId"
                                        sx={{ width: 'auto' }}
                                        size='small'
                                        options={raterGroups}
                                        getOptionLabel={(option) => option.name}
                                        onChange={handleGroupChange}
                                        value={formik.values.raterGroup}
                                        renderInput={(params) => <TextField {...params} label={"Rater Group"} />}
                                    />
                                    {formik.touched.raterGroup && formik.errors.raterGroup && (<div className="text-danger">{formik.errors.raterGroup}</div>)}
                                </div>
                            </div>
                            <div className="col-md-2 text-end">
                                <button type="submit" className="btn w-100 btn-primary mt-3">Add</button>
                            </div>
                        </div>
                    </form>
                    <div className="row">
                        <div className="col-8"></div>
                        <div className="col-2 text-end"><a href={`${process.env.REACT_APP_BASE_URL}assets/DemoFile.xlsx`} target="_blank" download={true}  className="btn w-100 btn-primary mb-2">Download Sample</a></div>
                        <div className="col-2 text-end">
                            <input 
                                type="file" 
                                className="account-file-input" 
                                id="fileUpload" 
                                name='fileUpload'
                                style={{ display: "none" }}
                                aria-describedby="file-upload-help" 
                                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                onChange={(e) => {
                                    onFileUpload(e.target.files[0]);
                                    e.target.value = ""; 
                                }}
                            />
                            <label
                                htmlFor="fileUpload"
                                className="btn w-100 btn-primary"                               
                            >
                                Upload Raters
                            </label>
                            
                        </div>

                    </div>
                </div>                                          
                <div className="col-md-12">                    
                    <div className="table-responsive row mb-3">
                        <table className="table table-striped">
                            <thead>
                                <tr key={'rater_tab_header'}>
                                    <th scope="col">S. No.</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Email</th>
                                    <th scope="col">Rater Group</th>
                                    <th scope="col">Status</th>
                                    {/* <th scope="col">Rater Group</th> */}
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                            subjectRaters.map((rater, index) => (
                                <tr key={'rater_tbl_'+index}>
                                    <th scope="row">{index+1}</th>
                                    <td>{rater.firstName+' '+rater.lastName}</td>
                                    <td>{rater.email}</td>
                                    <td>{rater.raterGroup.name}</td>
                                    <td><Stack spacing={1}>                   
                                            <Stack direction="row" spacing={1}>
                                            {
                                                rater.status === '0' ? 
                                                <Chip label="Pending" color="info" size="small" variant="outlined" />
                                                :
                                                <Chip label="Done" color="success" size="small" />
                                            }   
                                            </Stack>
                                        </Stack>
                                    </td>
                                    {/* <td>{findNameById(rater.raterGroup, groups)}</td> */}
                                    <td>
                                        <div className="d-flex">
                                        {assessmentSentAt !== null && rater.status === '0' ? 
                                        <>
                                            <Tooltip title="Send Reminder" size='small' className='icon icon-sm icon-secondary'>
                                                <IconButton onClick={() => sendReminder(rater.id)}>
                                                    <span className="bx b bx-paper-plane"></span>
                                                </IconButton>
                                            </Tooltip>                                            
                                            
                                        </>
                                        :""}
                                        <Tooltip onClick={() => editRater(rater)} title="Edit Rater" size='small' className='icon icon-sm icon-primary ms-2'>
                                            <IconButton>
                                                <span className="bx b bx-pencil"></span>
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Remove Rater" size='small' className='icon icon-sm icon-danger ms-2'>
                                            <IconButton onClick={() => removeRater(rater.id)}>
                                                <span className="bx b bx-trash"></span>
                                            </IconButton>
                                        </Tooltip>
                                        </div>
                                        <span className="text-success" style={{display:isSent===rater.id?'block':'none'}}>&nbsp; Sent!</span>
                                    </td> 
                                </tr>
                            )) 
                            }                                                            
                            </tbody>
                        </table>
                    </div>
                </div>  
            </Modal.Body>
        </Modal>
        <EditRater rater={rater} raterGroups={raterGroups} show={showEditRaterModal} setShow={setShowEditRaterModal} getRaters={getRaters}/>
        </>
    )
}